<template>
  <div>
    <!-- <pre>
      {{ composition }}
    </pre> -->
    <TitleLine class="text-capitalize mb-2" :title="composition.name" />

    <b-form-radio
      v-for="opt in composition.options"
      v-model="optSelected"
      :key="opt.value"
      :value="opt"
      :unchecked-value="null"
      @input="onCheck"
    >
      {{ opt.label }}
    </b-form-radio>
  </div>
</template>

<script>
import { Component, Prop, Vue } from 'vue-property-decorator'

import CompositionOrder from '@/models/compositionOrder.model'

@Component
export default class ProductComposition extends Vue {
  @Prop({
    type: Object,
    required: true,
  })
  composition

  optSelected = null

  onCheck(opt) {
    if (opt) {
      CompositionOrder.insert({
        data: {
          id: this.composition.name,
          name: opt.label,
          data: { ...opt },
          quantity: 1,
          price: 0,
          isAdition: false,
        },
      })

      this.$emit('updateOrder')
    }
  }
}
</script>

<style scoped></style>
